/**
 * @generated SignedSource<<f69a4f16cd66da279e5c5c79a3e88a48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SkillCategoryRow_company$data = {
  readonly id: string;
  readonly skillLevelsEnabled: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SkillRow_company">;
  readonly " $fragmentType": "SkillCategoryRow_company";
};
export type SkillCategoryRow_company$key = {
  readonly " $data"?: SkillCategoryRow_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"SkillCategoryRow_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillCategoryRow_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillLevelsEnabled",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillRow_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "ffa5bb312392142666072110e8350581";

export default node;
